/**
 *  logManageMentLeftModule
 *
 * Description 
 * rebuild:SMG 2016-4-20
 */
"use strict";
angular.module('logManageMentLeftModule', [
    "featureUsageStatisticsLeftModule"
]).
controller('logManageMentLeftCtrl', ['$scope', "trsHttpService", '$timeout', '$element', '$q', '$state', 'permissionService', function($scope, trsHttpService, $timeout, $element, $q, $state, permissionService) {
    initStatus();
    /**
     * [initStatus description] 初始化参数状态1
     */
    function initStatus() {
        $scope.path = $state.current.name;
        $scope.status = {};
        $scope.data = {};
        $scope.$root.narrowNavigation = true;
        /*getPermission().then(function() {
            autoGo();
        });*/
        $q.all([getPermission(), isAdministrator()]).then(() => {
            autoGo();
        });
    }
    /**
     * [isAdministrator description] 查询当前用户是不是系统管理员
     * @return {Boolean} [description]
     */
    function isAdministrator() {
        let deffer = $q.defer();
        permissionService.isAdministrator().then(function(data) {
            $scope.status.isAdministrator = data;
            deffer.resolve();
        });
        return deffer.promise;
    }
    /**
     * [autoGo description] 自动跳转
     * @return {[type]} [description]
     */
    function autoGo() {
        var pathArray = $scope.path.split(".");
        if (pathArray.length >= 3) {
            $scope.status.selectedModule = pathArray[2];
            if ($scope.status.selectedModule == 'featureusagestatistics') {
                getTenantList().then(resp => {
                    $scope.$root.narrowNavigation = false;
                });
            }
        } else {
            $timeout(function() {
                $element.find("li").eq(0).find("a")[0].click();
                if ($element.find("li").eq(0).find("li").length > 0) {
                    $element.find("li").eq(0).find("li").find("a")[0].click();
                }
            });
        }
    }
    /**
     * [getPermission description] 获取权限
     * @return {[type]} [description]
     */
    function getPermission() {
        var deffer = $q.defer();
        permissionService.getPermissionData().then(function(data) {
            // 返回数据是权限管控
            $scope.status.configureAccess = data.log; //给数据赋值
            deffer.resolve();
        });
        return deffer.promise;
    }
    /**
     * [goToPage description] 跳转不同的页面
     */
    $scope.goToPage = function(path) {
        $scope.$root.narrowNavigation = true; //进入窄导航模式
        $state.go("manageconfig.logmanage." + path);
        $scope.status.selectedModule = path;
    };
    /**
     * [goFeatureUsageStatistics description] 进入功能使用统计
     * @return {[type]} [description]
     */
    $scope.goFeatureUsageStatistics = function() {
        $scope.status.selectedModule = "featureusagestatistics";
        getTenantList().then(resp => {
            $scope.$root.narrowNavigation = false; //进入宽导航模式
        });
    };
    /**
     * [getTenantList description] 获取租户列表
     * @return {[type]} [description]
     */
    function getTenantList() {
        let deffer = $q.defer();
        let params = {
            serviceid: "mlf_buridecode",
            methodname: "gettenant"
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(resp => {
            $scope.data.tenantList = resp.data;
            deffer.resolve();
        });
        return deffer.promise;
    }
}]);